import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { LoginService } from '../services/LoginService'; 

export default function LoginPage() {
    const navigate = useNavigate();
    const loginService = new LoginService();

        const handleLogin = async (email, password) => {
        try {
            const userData = await loginService.performLogin({ email, password });
            
            // DEBUG: Check the browser console (F12) to see EXACTLY what the backend sent!
            console.log("Backend returned this userData:", userData);
           
            // BULLETPROOF ROLE CHECK
            const hasRole = (role) => {
                // Check both 'authorities' and 'roles' (depending on your JwtResponseDTO)
                const perms = userData.authorities || userData.roles || [];
                
                return perms.some(perm => {
                    // Case 1: It's an object like { "authority": "ROLE_ADMIN" }
                    if (typeof perm === 'object' && perm !== null) {
                        const authName = perm.authority || perm.role || '';
                        return authName === role || authName === `ROLE_${role}`;
                    }
                    // Case 2: It's a simple string like "ROLE_ADMIN" or "ADMIN"
                    if (typeof perm === 'string') {
                        return perm === role || perm === `ROLE_${role}`;
                    }
                    return false;
                });
            };

            const isAdmin = hasRole('ADMIN');
            const isUser = hasRole('USER');
            const isContributor = hasRole('CONTRIBUTOR'); 
            const isParticular = hasRole('PART'); 
            
            console.log("Roles found ->", { isAdmin, isUser, isContributor });

            if (userData.userId && (isAdmin || isUser || isContributor || isParticular)) {
                navigate(`/home/${userData.userId}`);
            } 
            else if (userData.userId) {
                localStorage.removeItem('accessToken');
                // Let's make the error message more helpful for debugging!
                throw new Error(`Accès refusé. Rôles reçus: ${JSON.stringify(userData.authorities || userData.roles)}`);
            } 
            else {
                localStorage.removeItem('accessToken');
                throw new Error('Erreur serveur : ID utilisateur manquant.');
            }

            return userData; 
        } catch (error) {
            console.error("Login failed:", error);
            throw error; 
        }
    };

    return (
        <div>
            <LoginForm onLogin={handleLogin} />
        </div>
    );
}